import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, LogIn, LogOut, User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const ActivitySummaryCard = ({ stats }) => {
  const { t } = useTranslation();

  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Calendar className="h-5 w-5" />
        {t('zktecoComp.activitySummary')}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid gap-4 md:grid-cols-3">
        <div className="text-center p-4 bg-muted rounded-lg">
          <LogIn className="h-8 w-8 mx-auto mb-2 text-green-500" />
          <div className="text-2xl font-bold text-green-500">{stats.checkIns}</div>
          <div className="text-sm text-muted-foreground">{t('zktecoComp.checkIns')}</div>
        </div>
        <div className="text-center p-4 bg-muted rounded-lg">
          <LogOut className="h-8 w-8 mx-auto mb-2 text-red-400" />
          <div className="text-2xl font-bold text-red-400">{stats.checkOuts}</div>
          <div className="text-sm text-muted-foreground">{t('zktecoComp.checkOuts')}</div>
        </div>
        <div className="text-center p-4 bg-muted rounded-lg">
          <User className="h-8 w-8 mx-auto mb-2" style={{ color: "#5e6ad2" }} />
          <div className="text-2xl font-bold" style={{ color: "#5e6ad2" }}>{stats.uniqueUsers}</div>
          <div className="text-sm text-muted-foreground">{t('zktecoComp.activeEmployees')}</div>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default ActivitySummaryCard;
